import { getCharacter } from 'src/graphql/queries/characters.graphql';
import type {
  IGetCharacterQuery,
  IGetCharacterQueryVariables,
} from 'src/graphql/queries/characters.graphql.types';
import useCharacterBuilderStore from 'src/stores/characterBuilder';
import { useQuery } from 'urql';
import usePermission from '../permissions/usePermissions';
import useRootUserRevalidation from '../useRootUserRevalidation';

const useCharacter = ({
  playerId,
  characterId,
}: {
  playerId: number;
  characterId: number;
}) => {
  const { isSafetyLockActive } = useCharacterBuilderStore();
  const { isPermitted: canOverride } = usePermission({
    action: 'update_character_data',
    characterId: Number(characterId),
  });
  const { isPermitted: canSeeInventory } = usePermission({
    action: 'show_character_inventory',
    characterId: Number(characterId),
  });
  const [{ data, error, fetching, stale }, refetch] = useQuery<
    IGetCharacterQuery,
    IGetCharacterQueryVariables
  >({
    query: getCharacter,
    variables: { playerId, characterId },
    requestPolicy: 'cache-and-network',
    pause: true,
  });
  const isStaged = data?.user?.character?.status === 'staged';

  useRootUserRevalidation({ refetch });

  return {
    data,
    error,
    player: data?.user,
    character: data?.user?.character,
    canEditSensitiveData: canOverride,
    canDisableSafetyLock: canOverride || isStaged,
    canEdit: (canOverride || isStaged) && !isSafetyLockActive,
    canSeeInventory,
    fetching,
    stale,
    refetch,
  };
};

export default useCharacter;
